import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Nav, NavItem, Tab } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUser, faFileImport } from '@fortawesome/pro-solid-svg-icons';

import { TABS } from './constants';
import { changeTab } from './store/actions/ui';
import { getActiveTab } from './store/selectors/ui';

import ImportsList from './imports';
import ImportRequestsList from './requests/index/import_requests_list';

export function Importer({ activeTab, onChangeTab }) {
  const renderActiveTab = () => {
    switch (activeTab) {
    case TABS.IMPORTS:
      return <ImportsList />;
    case TABS.REQUESTS:
      return <ImportRequestsList />;
    }
  };

  return (
    <Tab.Container defaultActiveKey={activeTab} id="importer-tab-container">
      <div className="importer-content">
        <div className="container my-4">
          <Nav bsStyle="pills" className="muted">
            <NavItem eventKey={TABS.IMPORTS} onClick={() => onChangeTab(TABS.IMPORTS)}>
              <FontAwesomeIcon icon={faFileImport} />
              <span className="ml-2">Imports</span>
            </NavItem>
            <NavItem eventKey={TABS.REQUESTS} onClick={() => onChangeTab(TABS.REQUESTS)}>
              <FontAwesomeIcon icon={faFileUser} />
              <span className="ml-2">Import Requests</span>
            </NavItem>
          </Nav>
        </div>
    
        <Tab.Content animation={false} mountOnEnter unmountOnExit>
          {Object.values(TABS).map(navKey => (
            <Tab.Pane eventKey={navKey} key={navKey}>
              {renderActiveTab(navKey)}
            </Tab.Pane>
          ))}
        </Tab.Content>
      </div>
    </Tab.Container>
  );
}

Importer.propTypes = {
  activeTab: PropTypes.oneOf(Object.values(TABS)).isRequired,
  onChangeTab: PropTypes.func.isRequired
};

Importer.defaultProps = {  
  activeTab: TABS.IMPORTS
};

const mapStateToProps = state => ({
  activeTab: getActiveTab(state)
});

const mapDispatchToProps = {
  onChangeTab: changeTab
};

export default connect(mapStateToProps, mapDispatchToProps)(Importer);
